<template>
  <ark-lb-tabs class="ark-leaderboard-tabs">
    <ark-lb-tabs-list class="ark-leaderboard-tabs__list">
      <tabs-item
        :key="tabKey"
        v-for="(tabName, tabKey) in tabs"
        :tabName="tabName"
        :tabKey="tabKey"
        :chosenPeriod="chosenPeriod"
        :choseTab="choseTab"
      ></tabs-item>
    </ark-lb-tabs-list>
  </ark-lb-tabs>
</template>

<script>
  import tabsItem from '../TabsItem/TabsItem'

  export default {
    components: {tabsItem},
    props: ['tabs', 'chosenPeriod'],
    methods: {
      choseTab: function (chosenTab) {
        this.$emit('update:chosenPeriod', chosenTab)
      }
    }
  }
</script>

<style lang="scss" src="./Tabs.scss"></style>



// WEBPACK FOOTER //
// Tabs.vue?7c0dd0b6